// config.prod.js
module.exports = {
    ENVIRONMENT: 'mainnet',
    PROJECT_ID: 'c679f6063761066df4de699e48a8459b',
    PROXY_CONTRACT_ADDRESS: 'erd1qqqqqqqqqqqqqpgqcs6cwyy6s5v9ggcx3gz4zhyu6k60gvya72kqqagntm', // TODO
    MULTIVERSX_API_URL: 'https://api.multiversx.com',
    MULTIVERSX_EXPLORER_URL: 'https://explorer.multiversx.com',
    DISPLAYED_CURRENCY_CODE: 'TADA',
    TOKEN_IDENTIFIER: 'TADA-5c032c',
    TADA_API: 'https://api.ta-da.io/',
};
